module.exports = __webpack_public_path__ + "media/images/preview/preview_laptop_2-246a251fb185164abfc9b5ca79507252.png";